<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icontiku1"></i>
      考试说明
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-end margin-bottom-sm">
        <el-button type="primary" @click="subdialogDialog = true">
          <p class="flex align-center font-size">
            <i class="iconfont iconxinzeng margin-right-xs"></i>新增
          </p>
        </el-button>
      </div>
      <div class="table-warpper">
        <el-table
            :data="noticeList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="ID">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.type | type }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="说明">
            <template slot-scope="scope">
              <div class="table-item ovHideOnHeight" v-html="scope.row.desc">
              </div>
            </template>
          </el-table-column>
          <el-table-column label="添加时间">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.update_time ? scope.row.update_time : scope.row.add_time }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row)"
                >编辑
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    @click="deleteItem(scope.row.id)"
                >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="noticeList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <subdialog-dialog
        :setId="setId"
        :setItem="setItem"
        :subdialogDialog="subdialogDialog"
        @cancelDialog="cancelDialog"
    />

  </div>
</template>

<script>
import {examExplainList, examExplainDel} from "@/api/projectOffice";
import subdialogDialog from "@/views/projectOffice/page/dialog/explainDialog";

export default {
  name: "explain",
  data() {
    return {
      noticeList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      setItem: {},
      subdialogDialog: false
    };
  },
  components: {
    subdialogDialog
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：题库管理 > 考试说明",
        false
    );
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
    }
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await examExplainList(
          this.page,
          this.limit);
      this.noticeList = _list.data.list;
      this.total = _list.data.count;
    },
    setPath() {
      this.$router.push({
        path: '/projectOffice/explain',
        query: {
          page: this.page,
        }
      })
    },
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.subdialogDialog = true;
    },
    deleteItem(id) {
      this.$confirm("确定要删除该考试说明吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await examExplainDel(id);
      if (this.noticeList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
      }
    },
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  },
  filters: {
    type(type) {
      switch (Number(type)) {
        case 1:
          return '基础知识'
        default:
          return '案例考试'
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>